import React from "react";

const MikaCanada = () => {
  return (
    <svg
      width="202"
      height="180"
      viewBox="0 0 202 180"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_80_6209)">
        <g filter="url(#filter0_d_80_6209)">
          <circle cx="100.778" cy="87.7167" r="78.7782" fill="white" />
        </g>
        <path
          d="M147.106 120.705C150.526 120.705 153.298 117.912 153.298 114.466C153.298 111.02 150.526 108.227 147.106 108.227C143.686 108.227 140.914 111.02 140.914 114.466C140.914 117.912 143.686 120.705 147.106 120.705Z"
          fill="#FF878F"
        />
        <path
          d="M114.522 60.3911C108.874 60.389 103.432 62.5369 99.2839 66.4059C98.9312 66.7361 98.4679 66.9196 97.9869 66.9196C97.5058 66.9196 97.0425 66.7361 96.6898 66.4059C92.5415 62.5369 87.0999 60.389 81.4513 60.3911C68.9209 60.3911 58.7646 70.7684 58.7646 83.5687V114.273C58.7646 117.681 61.3566 120.581 64.6895 120.703C65.521 120.728 66.349 120.585 67.1242 120.28C67.8993 119.975 68.6055 119.516 69.2007 118.929C69.7958 118.343 70.2677 117.641 70.5879 116.866C70.9082 116.091 71.0703 115.259 71.0646 114.42V83.8431C71.0646 77.979 75.7153 73.2313 81.4409 73.2313C87.1769 73.2313 91.8275 77.9832 91.8275 83.8431V114.273C91.8275 117.681 94.4195 120.581 97.7523 120.703C98.5837 120.728 99.4117 120.585 100.187 120.28C100.962 119.975 101.668 119.516 102.263 118.929C102.858 118.342 103.329 117.641 103.649 116.866C103.97 116.091 104.131 115.259 104.125 114.42V83.8431C104.125 77.979 108.776 73.2313 114.512 73.2313C120.248 73.2313 124.899 77.9832 124.899 83.8431V114.273C124.899 117.681 127.493 120.581 130.826 120.703C131.657 120.728 132.485 120.585 133.26 120.28C134.035 119.975 134.741 119.516 135.336 118.929C135.931 118.342 136.403 117.641 136.723 116.866C137.043 116.091 137.205 115.259 137.199 114.42V83.5687C137.209 70.7684 127.053 60.3911 114.522 60.3911Z"
          fill="#003125"
        />
        <path
          d="M64.9568 60.807C68.3767 60.807 71.149 58.0135 71.149 54.5676C71.149 51.1216 68.3767 48.3281 64.9568 48.3281C61.537 48.3281 58.7646 51.1216 58.7646 54.5676C58.7646 58.0135 61.537 60.807 64.9568 60.807Z"
          fill="#00D598"
        />
        <path
          d="M149.481 7.54933C149.953 6.53906 151.389 6.53906 151.861 7.54933L158.407 21.5759C158.537 21.8554 158.762 22.08 159.042 22.2104L173.068 28.7567C174.078 29.2282 174.078 30.6647 173.068 31.1362L159.042 37.6824C158.762 37.8129 158.537 38.0375 158.407 38.3169L151.861 52.3435C151.389 53.3538 149.953 53.3538 149.481 52.3435L142.935 38.3169C142.805 38.0375 142.58 37.8129 142.301 37.6824L128.274 31.1362C127.264 30.6647 127.264 29.2282 128.274 28.7567L142.301 22.2104C142.58 22.08 142.805 21.8554 142.935 21.5759L149.481 7.54933Z"
          fill="#FFD440"
        />
        <path
          d="M40.9532 160.174L44.3637 174.088L41.4216 174.648L39.4822 160.454C39.4489 160.221 39.3636 159.999 39.2324 159.803C39.1013 159.607 38.9277 159.443 38.7245 159.323C38.5213 159.203 38.2936 159.13 38.0581 159.109C37.8227 159.089 37.5856 159.121 37.3642 159.204L23.792 164.335L24.6962 158.763C24.7336 158.541 24.7004 158.313 24.6012 158.111C24.502 157.909 24.3418 157.743 24.143 157.636L6.40063 148.155L9.55887 145.883C9.77193 145.728 9.92108 145.501 9.97832 145.245C10.0356 144.989 9.99694 144.721 9.86973 144.491L5.05664 135.754L14.272 135.941C14.5215 135.945 14.7649 135.863 14.9609 135.709C15.1569 135.555 15.2934 135.338 15.3474 135.095L16.298 130.746L24.619 136.823C24.8088 136.96 25.0377 137.031 25.2715 137.026C25.5053 137.021 25.7315 136.941 25.916 136.798C26.1005 136.654 26.2334 136.455 26.2948 136.23C26.3562 136.005 26.3428 135.766 26.2566 135.55L19.6615 119.053L25.5921 121.113C25.7316 121.163 25.8797 121.183 26.0274 121.173C26.1751 121.163 26.3193 121.123 26.4509 121.055C26.5824 120.987 26.6987 120.893 26.7925 120.779C26.8862 120.665 26.9554 120.533 26.9958 120.391L30.4014 108.74L37.8488 118.325C37.9385 118.442 38.0515 118.54 38.1806 118.612C38.3098 118.683 38.4525 118.728 38.5998 118.743C38.7471 118.758 38.8958 118.742 39.0369 118.697C39.178 118.652 39.3083 118.579 39.4198 118.481L44.1788 114.386L44.1052 132.153C44.1046 132.386 44.1798 132.613 44.3196 132.799C44.4593 132.986 44.6561 133.122 44.8804 133.188C45.1047 133.254 45.3445 133.245 45.5636 133.164C45.7828 133.082 45.9697 132.932 46.0961 132.736L51.6028 124.026L54.0846 127.722C54.224 127.928 54.4307 128.08 54.6696 128.151C54.9086 128.223 55.165 128.209 55.3955 128.114L63.898 124.555L62.6308 134.449C62.5969 134.709 62.6595 134.973 62.8069 135.19C62.9543 135.407 63.1764 135.564 63.4314 135.629L67.2034 136.582L54.1848 151.919C54.039 152.091 53.951 152.304 53.9329 152.528C53.9149 152.753 53.9677 152.977 54.0841 153.17L56.972 158.02L42.4638 158.233C42.2274 158.237 41.995 158.295 41.7837 158.4C41.5723 158.506 41.3873 158.658 41.2424 158.844C41.0974 159.03 40.9962 159.246 40.9462 159.477C40.8961 159.707 40.8986 159.945 40.9532 160.174Z"
          fill="#D5202C"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_80_6209"
          x="6"
          y="-6.06152"
          width="189.557"
          height="189.557"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0779338 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_80_6209"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_80_6209"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_80_6209">
          <rect width="202" height="180" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MikaCanada;
